export default __webpack_public_path__ + "static/media/PROCESSMETHOD_SHEETMETAL_LASER_CUTTING.5283c5dc.png";